import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { ContentSpacing } from '@estee/elc-base-theme';
import { ITranslationsCollection, configConsumer } from '@estee/elc-service';
import {
    SEARCH_TYPE_PARAM,
    PREDICTIVE_SEARCH_PARAM,
    FILTERS_SEARCH_PARAM
} from '../../constants/Search';
import { IItemTypeahead } from '../../../internal/interfaces/ISearchInterfaces';
import { suggestionText, suggestionWrapper } from '../../../theme/default-theme';
import { formatDataAttribute } from '../../utils/FormatDataAttritube';
import { classes } from '../../utils/Classes';
import { formatCount } from '../../utils/FormatCount';

const SuggestionDimensionWrapper = styled.li`
    padding: ${ContentSpacing.space10} 0;
    ${suggestionWrapper};
    text-align: left;
`;

const SuggestionLink = styled.a`
    margin: 0;
    display: inline-block;
    vertical-align: middle;
    max-width: 400px;
    overflow: hidden;
    ${suggestionText};
`;

export interface ISearchSuggestionListPropsConfig {
    useSquareBrackets?: boolean;
}
export interface ISearchSuggestionListProps {
    translations?: ITranslationsCollection;
    searchUrl?: string;
    limitedTypeaheadResults: IItemTypeahead[];
    filterParam: string;
    searchParam: string;
    searchTermSelected(searchTerm: string): () => void;
    config?: ISearchSuggestionListPropsConfig;
}

@configConsumer(['useSquareBrackets'])
@observer
export class SearchSuggestionList extends React.Component<ISearchSuggestionListProps> {
    private searchSuggestionsValue: string = classes('search-suggestion-value');
    private searchSuggestionLinkClassnames: string = classes('search-suggestion-link');
    private searchTypeaheadCountClassnames: string = classes('search-typeahead-count');
    private searchTypeaheadValueClassnames: string = classes('search-typeahead-value');
    public render() {
        const {
            limitedTypeaheadResults,
            filterParam,
            searchParam,
            searchUrl,
            searchTermSelected,
            config: { useSquareBrackets } = {}
        } = this.props;

        return (
            limitedTypeaheadResults.length > 0 &&
            limitedTypeaheadResults.map((typeaheadValue: IItemTypeahead) => (
                <SuggestionDimensionWrapper
                    data-test-id="SEA-Suggestion"
                    key={typeaheadValue.link}
                    className={this.searchSuggestionsValue}
                >
                    {/* @TODO  remove unused translation field and legacy Drupal CSS styles in https://jira.esteeonline.com/browse/SDSEARCH-2099*/}
                    <SuggestionLink
                        className={this.searchSuggestionLinkClassnames}
                        href={`${searchUrl}${searchParam}${encodeURIComponent(
                            typeaheadValue.label
                        )}${filterParam}${
                            typeaheadValue.link
                        }${SEARCH_TYPE_PARAM}${PREDICTIVE_SEARCH_PARAM}${FILTERS_SEARCH_PARAM}`}
                        role="button"
                        aria-label={typeaheadValue.label}
                        onClick={searchTermSelected(typeaheadValue.label)}
                        title={typeaheadValue.label}
                    >
                        <span
                            className={this.searchTypeaheadValueClassnames}
                            data-test-id={`SEA-Predective-Result-${formatDataAttribute(
                                typeaheadValue.label
                            )}`}
                        >
                            {typeaheadValue.label}
                        </span>
                    </SuggestionLink>
                    {typeaheadValue.count ? (
                        <span className={this.searchTypeaheadCountClassnames}>
                            {formatCount(typeaheadValue.count, useSquareBrackets)}
                        </span>
                    ) : null}
                </SuggestionDimensionWrapper>
            ))
        );
    }
}
